import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';

const useCalendarEvents = () => {
  const addEvent = useCallback(async (val) => {
    try {
      return await ajax.post(`events/add-event`, val);
    } catch (error) {
      return error;
    }
  });

  const updateSelectedEvent = useCallback(async (val) => {
    try {
      return await ajax.post(`events/update-event`, val);
    } catch (error) {
      return error;
    }
  });

  const getCalendarEventsForWeek = useCallback(async (val) => {
    try {
      const values = { userId: val };
      return await ajax.post(`events/get-week-events`, values);
    } catch (error) {
      return error;
    }
  });

  const getCalendarEventsByuser = useCallback(async (val) => {
    try {
      const values = { userId: val };
      return await ajax.post(`events/get-my-event`, values);
    } catch (error) {
      return error;
    }
  });

  const getCalendarEvents = useCallback(async (val) => {
    try {
      return await ajax.post(`events/get-all-events`, val);
    } catch (error) {
      return error;
    }
  });

  const deleteEvent = useCallback(async (val) => {
    try {
      const value = { eventId: val };
      return await ajax.post(`events/delete-event`, value);
    } catch (error) {
      return error;
    }
  });

  const getSingleEvent = useCallback(async (val) => {
    try {
      const values = { eventId: val };
      return await ajax.post(`events/get-single-announcement`, values);
    } catch (error) {
      return error;
    }
  });

  return {
    addEvent,
    updateSelectedEvent,
    getCalendarEventsByuser,
    getCalendarEvents,
    getCalendarEventsForWeek,
    deleteEvent,
    getSingleEvent,
  };
};

export default useCalendarEvents;
